import { PawPrint, BadgeCheck, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const verifiedShelters = [
  { name: "KTOZ Kraków", city: "Kraków" },
  { name: "Schronisko LPGK", city: "Legnica" },
  { name: "Koci Azyl Żagań", city: "Żagań" },
  { name: "Schronisko Kielce", city: "Kielce" },
  { name: "Schronisko", city: "Piotrków Tryb." },
  { name: "Schronisko Kiczarów", city: "Stargard" },
  { name: "Schronisko Chełm", city: "Chełm" },
  { name: "Schronisko", city: "Milanówek" },
  { name: "Schronisko Borek", city: "Rzezawa" },
  { name: "Schronisko Ciapek", city: "Hajnówka" },
  { name: "Schronisko", city: "Sokółka" },
  { name: "Jedno Serce", city: "Szumowo" },
];

// Colors for gradient badges
const badgeColors = [
  "#4E8A6E", "#5D9A7D", "#6BAF8D", "#4A7A5E",
  "#3D6B51", "#5A9878", "#4E8A6E", "#6BAF8D",
  "#4A7A5E", "#5D9A7D", "#3D6B51", "#5A9878",
];

export const InstagramStory12Verified2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f5f9f7",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Decorative elements */}
      <div
        style={{
          position: "absolute",
          top: "100px",
          left: "-80px",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(78,138,110,0.08)",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "150px",
          right: "-100px",
          width: "350px",
          height: "350px",
          borderRadius: "50%",
          background: "rgba(78,138,110,0.06)",
          zIndex: 1,
        }}
      />

      {/* Safe zone content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 70px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header with sparkles */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", marginBottom: "16px" }}>
            <Sparkles style={{ width: "36px", height: "36px", color: "#F4C430" }} />
            <span style={{ fontSize: "36px", fontWeight: 700, color: "#4E8A6E" }}>
              Mamy już
            </span>
            <Sparkles style={{ width: "36px", height: "36px", color: "#F4C430" }} />
          </div>
          <div
            style={{
              fontSize: "140px",
              fontWeight: 800,
              color: "#2D5A3D",
              lineHeight: 0.9,
              marginBottom: "8px",
            }}
          >
            12
          </div>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "12px",
              background: "#4E8A6E",
              borderRadius: "100px",
              padding: "14px 36px",
            }}
          >
            <BadgeCheck style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
            <span style={{ fontSize: "32px", fontWeight: 700, color: "#FFFFFF" }}>
              ZWERYFIKOWANYCH
            </span>
          </div>
        </div>

        {/* Shelters as flowing badges */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexWrap: "wrap",
            gap: "14px",
            justifyContent: "center",
            alignContent: "center",
            padding: "0 10px",
          }}
        >
          {verifiedShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.98)",
                borderRadius: "100px",
                padding: "14px 24px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                border: `2px solid ${badgeColors[i]}`,
              }}
            >
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: badgeColors[i],
                }}
              />
              <span style={{ fontSize: "26px", fontWeight: 700, color: "#2D5A3D", whiteSpace: "nowrap" }}>
                {shelter.city}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <p style={{ fontSize: "32px", fontWeight: 600, color: "#4A7A5E", marginBottom: "20px" }}>
            Zobacz czego potrzebują 👆
          </p>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
